import { cn } from "@prostocheck/shared";

import { ILogoProps } from "./logo.models";

export const Logo = ({ className, withWordmark = true }: ILogoProps) => (
  <span className={cn("inline-flex items-center gap-2", className)}>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      aria-hidden="true"
      className="shrink-0"
    >
      <rect width="28" height="28" rx="8" className="fill-brand-600" />
      <path
        d="M8 14.5l4 4 8-9"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    {withWordmark && (
      <span className="text-lg font-semibold tracking-tight text-ink-900">
        Prosto<span className="text-brand-600">Check</span>
      </span>
    )}
  </span>
);
